var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e4319592-040a-4a71-b44b-4d296da75a09",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-914633c9-2a12-4732-a83e-fb2e4dd31025 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-914633c9-2a12-4732-a83e-fb2e4dd31025",
    d: "M12.03,22.69v-3.31s-.03,0-.05,0c-1.62-.02-2.87-1.29-2.91-2.95-.03-1.32-.03-2.71,0-4.14.03-1.68,1.28-2.96,2.9-2.97,2.69-.01,5.39-.02,8.08,0,1.64.01,2.88,1.31,2.9,3.03.01,1.3,0,2.59,0,3.89-.01,1.84-1.26,3.13-3.03,3.13h-.39c-1.18,0-2.36,0-3.55,0h-.11s-3.84,3.32-3.84,3.32ZM14.02,17.37v.94s1.1-.94,1.1-.94h.36s.51,0,.51,0c1.17.01,2.35,0,3.52,0h.39c.85,0,1.03-.62,1.03-1.15,0-1.29.01-2.58,0-3.86,0-.52-.29-1.04-.91-1.05-2.69-.02-5.37-.01-8.06,0-.54,0-.9.4-.91,1-.03,1.4-.03,2.77,0,4.06.01.59.39.98.94.99.31,0,1.01,0,1.01,0h1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.29c2015cf7b44ce98df09bb3aae5727e.svg";
export { ForwardRef as ReactComponent };